export default "__VITE_ASSET__2066f838__"